import axios from "axios"

import {
	accessControl,
	common,
	contentTypeForm,
	acceptHeader
} from "./helper.header";

import { store } from '@/store'

import { decodeLaravelValidationErrors, isEmpty } from "@/utilities";

const api = axios.create({
	baseURL: `${process.env?.VUE_APP_API_ADDRESS}`,
	withCredentials: true, // required to handle the CSRF token
	headers: {
		...common(),
		...accessControl(),
		...contentTypeForm(),
		...acceptHeader(),
		'X-XSRF-TOKEN': document?.querySelector('meta[name="csrf-token"]')?.getAttribute('content'),
	}
});

/**
 * Add a request interceptor
 */
api.interceptors.request.use(function (config) {
	
	return config;
}, function (error) {
	// Do something with request error
	return Promise.reject(error);
});

/*
 * Add a response interceptor
 */
api.interceptors.response.use(
	(response) => {
		return response
	},
	(error) => {

		let { response } = error;
		let { data, status } = response || {};

		switch (status) {
			case 403:
				store.dispatch('alert/createAlertErrors', "You are not authorized for this action.", { root: true });
				return error;
			case 419:
				store.dispatch("auth/unauthorized", null, { root: true })
				break;
			case 422:
				return error;
			case 500:
				return error;
			default:
				return {
					error: true,
					status: status || {},
					...response
				};
		}
	}
);

export async function apiRequest(url, requestOptions) {
	try {
		return await api(url, requestOptions);
	} catch (error) {
		console.log("try/catch error in API request");
		return error
	}
}
